import { cn } from '~/utils/cn';

interface PropsProgressBar {
  value: number;
  max?: number;
  className?: string;
  trackClassName?: string;
  fillClassName?: string;
}

export default function ProgressBar({
  value,
  max = 100,
  className,
  trackClassName,
  fillClassName,
}: PropsProgressBar) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className={cn('h-[6px] w-full rounded-full bg-intense-03 overflow-hidden', trackClassName, className)}>
      <div
        className={cn('h-full bg-primary-01 rounded-full transition-all', fillClassName)}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
